module.exports = __webpack_public_path__ + "static/media/desktopScreenshot03.7ac122d3.jpg";